module.exports = __webpack_public_path__ + "img/crypto-dai.1a84a86b.svg";